import PropTypes from "prop-types"
import React, { useCallback, useEffect, useRef, useState } from "react"
import Helmet from "react-helmet"
import { withRouter } from "react-router-dom"

import api from "apis"
import GenericNotFound from "app/generic-not-found"
import { getHreflangs } from "helpers/application"

export default function fetchArticle(WrappedComponent) {
  const FetchArticle = ({ articleData, match, staticContext, ...props }) => {
    const [article, setArticle] = useState(articleData?.article || {})
    const [isLoading, setIsLoading] = useState(false)
    const cancelled = useRef(false)

    const articlePath = match.params.article_path

    const getArticle = useCallback(async () => {
      if (
        !cancelled.current &&
        (Object.keys(article).length === 0 || article.url_path !== articlePath)
      ) {
        setIsLoading(true)

        try {
          const response = await api.get(`/blog/${articlePath}.json`)

          setArticle(response.article)
          setIsLoading(false)
        } catch (error) {
          console.log(error)
          setIsLoading(false)
        }
      }
    }, [articlePath])

    useEffect(() => {
      getArticle()
    }, [getArticle])

    useEffect(() => {
      return () => (cancelled.current = true)
    }, [])

    if (article?.not_found) {
      return <GenericNotFound staticContext={staticContext} />
    }

    return (
      <>
        <Helmet>
          {article?.title && <title>{article.title}</title>}
          {article?.seo_description && (
            <meta content={article.seo_description} name="description" />
          )}
          {article?.seo_description && (
            <meta content={article.seo_description} property="og:description" />
          )}
          <link
            href={`https://${sl.config.site_url}/blog/${article?.url_path}`}
            rel="canonical"
          />
          {getHreflangs(`/blog/${article.url_path}`).map(
            ({ href, hreflang }) => (
              <link
                href={href}
                hrefLang={hreflang}
                key={hreflang}
                rel="alternate"
              />
            )
          )}
        </Helmet>
        <WrappedComponent article={article} isLoading={isLoading} {...props} />
      </>
    )
  }

  FetchArticle.propTypes = {
    articleData: PropTypes.object,
    match: PropTypes.object,
    staticContext: PropTypes.object,
  }

  return withRouter(FetchArticle)
}
